function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49984 0.5C1.0396 0.5 0.666504 0.873096 0.666504 1.33333C0.666504 1.79357 1.0396 2.16667 1.49984 2.16667H16.4998C16.9601 2.16667 17.3332 1.79357 17.3332 1.33333C17.3332 0.873096 16.9601 0.5 16.4998 0.5H1.49984Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.666504 5.5C0.666504 5.03976 1.0396 4.66667 1.49984 4.66667H9.83317C10.2934 4.66667 10.6665 5.03976 10.6665 5.5C10.6665 5.96024 10.2934 6.33333 9.83317 6.33333H1.49984C1.0396 6.33333 0.666504 5.96024 0.666504 5.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49984 8.83333C1.0396 8.83333 0.666504 9.20643 0.666504 9.66667C0.666504 10.1269 1.0396 10.5 1.49984 10.5H16.4998C16.9601 10.5 17.3332 10.1269 17.3332 9.66667C17.3332 9.20643 16.9601 8.83333 16.4998 8.83333H1.49984Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1.49984 13C1.0396 13 0.666504 13.3731 0.666504 13.8333C0.666504 14.2936 1.0396 14.6667 1.49984 14.6667H9.83317C10.2934 14.6667 10.6665 14.2936 10.6665 13.8333C10.6665 13.3731 10.2934 13 9.83317 13H1.49984Z",
  fill: "white"
});

function SvgIconAlignLeftAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlignLeftAlt);
export default __webpack_public_path__ + "static/media/icon-align-left-alt.57dd0075.svg";
export { ForwardRef as ReactComponent };